import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-copy-text-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatInputModule, MatIconModule],
  templateUrl: './copy-text-dialog.component.html',
  styleUrl: './copy-text-dialog.component.scss',
})
export class CopyTextDialogComponent {
  text!: string;

  constructor(
    public dialogRef: MatDialogRef<CopyTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { text: string }
  ) {
    this.text = data.text;
  }

  handleCopy() {
    navigator.clipboard.writeText(this.text);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  goToUrl() {
    window.open(this.text, '_blank');
  }
}
